import useTitle from 'hooks/useTitle'

import CsvSheetCommonWrapper from '../Shared/CsvSheetCommon'

const FintechSheets = () => {
    useTitle('Fintech Sheets')
    return <CsvSheetCommonWrapper type={'fintech'} />
}

export default FintechSheets
